// buildFormPath helps to build a complete path for the formik field
// Let's say you have a form field 'name' but the field is a nested part of another form field 'user' (e.g. user.name)
// That way values will be set properly on the form state
export function buildFormPath(name: string, path?: string) {
  if (!path) {
    return name;
  }

  return `${path}.${name}`;
}
